import { useState } from 'react';
import { getLabel } from '../data/labels';
import { handleMouseOverTooltip, hideTooltip, iconSportCssClass } from '../data/utils';
import { ReactComponent as CollapseIcon } from '../icons/up.svg';
import { usePrematchData } from '../prematch/PrematchDataFetcher';

export default function MatchHeader(props) {
    const prematchData = usePrematchData();
    const [toggled, setToggled] = useState(props.toggled);
    
    function handleToggle() {
        setToggled(!toggled);
    }
    
    const match = props.match;
    const sport = prematchData.sportById[match.sportRef];
    const country = sport.categoryById[match.categoryRef];
    const desc = `${sport.descrizione} - ${country.descrizione} | ${match.dateShort}`;

    const icoSport = iconSportCssClass(sport.id, sport.iconClass);

    return (
        <>
            <div className="l_1_1_2">
                <div className="nome-competizione-sport" onClick={handleToggle}>
                    <div className={`img-fluid margine-dx ico-sport ${icoSport}`}></div>
                    <div className={`img-fluid margine-dx ico-cat ${country.categoryIcon}`}></div>
                    <span className="grassetto">{desc}</span>
                </div>
                <div className="icone-controllo-sport-centrale">
                    {toggled ?
                        <CollapseIcon
                            className="margine-dx pointer tasto-collassa"
                            onClick={handleToggle}
                            onMouseOver={handleMouseOverTooltip}
                            onMouseOut={hideTooltip}
                            data-desc={getLabel('prematch_page.control_icon.collapse')}
                        />
                        :
                        <CollapseIcon
                            className="margine-dx pointer tasto-collassa ruota-180"
                            onClick={handleToggle}
                            onMouseOver={handleMouseOverTooltip}
                            onMouseOut={hideTooltip}
                            data-desc={getLabel('prematch_page.control_icon.expand')}
                        />
                    }
                </div>
            </div>
            {toggled && props.children}
        </>
    );
}
